/** @flow */

import api from 'common/services/api';
import SalesPromotion from 'common/modules/sales/domain/SalesPromotion';
import type { SalesPromotionParameters } from 'common/modules/sales/domain/SalesPromotionParameters';

class PromotionsAPI {
  buildHeaders = (token: string): Object => ({ Authorization: 'Bearer ' + token });

  async createNewPromotion(callSign: string, token: string, promotion: SalesPromotionParameters): Promise<SalesPromotion> {
    const url = `/statsradio/${callSign}/sales-promotions`;

    const { data } = await api.post(url, promotion, { headers: this.buildHeaders(token) });

    return SalesPromotion.parse(data);
  }

  async fetchPromotions(callSign: string, token: string): Promise<SalesPromotion[]> {
    const url = `/statsradio/${callSign}/sales-promotions`;

    const { data } = await api.get(url, {}, { headers: this.buildHeaders(token) });

    return data.map(SalesPromotion.parse);
  }
}

export default new PromotionsAPI();



// WEBPACK FOOTER //
// ./src/statsradio/modules/promotions/services/PromotionsAPI.js